import React from "react";
export const TLContext = React.createContext();
